// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sider[data-v-2e722420]{box-shadow:inset -1px 0 0 #f0f0f0;min-width:256px!important}.chartjs-tooltip[data-v-2e722420]{opacity:1;position:absolute;background:rgba(0,0,0,.7);color:#fff;border-radius:3px;transition:all .1s ease;pointer-events:none;transform:translate(-50%)}canvas[data-v-2e722420]{cursor:pointer}", ""]);
// Exports
module.exports = exports;
